import request from "@/utils/request/index";

export enum Api {
  FETCH_EXHIBITION_TEMPLATE_LIST = "/exhibitionItemsTemplate/queryPage",
  FETCH_ALL_EXHIBITION_TEMPLATE_LIST = "/exhibitionItemsTemplate/queryBySourceType",
  FETCH_TEMPLATE_DETAIL = "/exhibitionItemsTemplate/getInfoById",
  FETCH_TEMPLATE_DETAIL_CODE = "/exhibitionItemsTemplate/getInfoByCode",
  CREATE_EXHIBITION = "/userExhibitionItems/saveOrUpdate",
  OCDEPHONE = "/sys/smsLoginOrRegisterCode",
  LOGINPHONE = "/sys/userLoginByMobile",
  EXHIBITIONPAGE = "/userExhibitionItems/recentUseQueryPage",
  RENAME = "/userExhibitionItems/rename",
  FETCH_MY_EXIBITION_LIST = "/userExhibitionItems/queryPage",
  FETCH_MY_EXIBITION_DETAILS = "/userExhibitionItems/info",
  FETCH_EXIBITION_MENU = "/tenant/menu/getTreeByExhibitionId",
  FETCH_TEMPLACE_PRICE = "/exhibitionItemsTemplatePrice/queryListByTemplateId",
  CLONE_EXBITION = "/userExhibitionItems/copy",
  FETCH_TREE_INFO = "/bigTree/getTreeByTenantId", //查询大树节点信息
  DELETE_EXBITION = "/userExhibitionItems/delete",
  FETCH_TREE_TAG = "/treeContent/abelGroupAll", //大树标签查询
  OVERWIRTE_TREE_CONTENT = "/userExhibitionItems/useByLabel",
  FETCH_EXBITION_INFO_BY_CODE = "/userExhibitionItems/getInfoByCode",
  FETCH_TEM_DETAILS_BY_EXBITIONID = "/exhibitionItemsTemplate/getInfoByUserItemsId",
  PLATFORM_TOKEN = "/sys/getCentralPlatformToken",
  PERMUATATION_TOKEN = "/sys/permutationToken",
}
// 获取展项模板列表
export const fetchExhibitionTemplateList = (data?: any) =>
  request.post(Api.FETCH_EXHIBITION_TEMPLATE_LIST, data);

// 按分类获取模板列表
export const fetchAllExhibitionTemplateList = (data?: any) =>
  request.get(Api.FETCH_ALL_EXHIBITION_TEMPLATE_LIST, data);
// 查询模板价格列表
export const fetchTemplatePrice = (data?: any) =>
  request.get(Api.FETCH_TEMPLACE_PRICE, data);

// 最近使用
export const historyPage = (data?: any, config?: axiosConfig) =>
  request.post(Api.EXHIBITIONPAGE, data, config);

// 重命名
export const changeRename = (data?: any) => request.post(Api.RENAME, data);
// id查模板详情
export const fetchExhibitionTemplateDetail = (data?: any) =>
  request.get(Api.FETCH_TEMPLATE_DETAIL, data);
//code查模板详情
export const fetchExhibitionTemplateDetailByCode = (data?: any) =>
  request.get(Api.FETCH_TEMPLATE_DETAIL_CODE, data);

// 创建展项
export const createExbition = (data?: any) =>
  request.post(Api.CREATE_EXHIBITION, data);
// 克隆展项
export const cloneExbiton = (data?: any) =>
  request.post(Api.CLONE_EXBITION, data);

// 查询我的展项
export const fetchMyExibition = (data?: any, config?: axiosConfig) =>
  request.post(Api.FETCH_MY_EXIBITION_LIST, data, config);
// 删除我的展项
export const deleteMyExibition = (data?: any, config?: axiosConfig) =>
  request.post(Api.DELETE_EXBITION, data, config);

// id查展项详情
export const fetchExhibitionDetail = (data?: any) =>
  request.get(Api.FETCH_MY_EXIBITION_DETAILS + "/" + data.id);

//查询大树节点信息
export const fetchTreeInfo = () =>
  request.get(Api.FETCH_TREE_INFO, { tenantId: 1 });

//根据code查询大树展项内容
export const fetchExbitionInfoByCode = (data?: any, config?: axiosConfig) =>
  request.get(Api.FETCH_EXBITION_INFO_BY_CODE, data, config);
//根据展项id查展项模板详情
export const fetchTemplateDetailsByExId = (data?: any, config?: axiosConfig) =>
  request.get(Api.FETCH_TEM_DETAILS_BY_EXBITIONID, data, config);

//查询大树节点信息
export const fetchTreeTagList = () => request.get(Api.FETCH_TREE_TAG);

//大树套用内容
export const overwriteTreeContent = (data?: any, config?: axiosConfig) =>
  request.post(Api.OVERWIRTE_TREE_CONTENT, data, config);
// 获取中台token
export const getPlatformToken = (data?: any) =>
  request.get(Api.PLATFORM_TOKEN, data);

// 置换token
export const permutationToken = (data?: any) =>
  request.get(Api.PERMUATATION_TOKEN, data);
